import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Spinner,
  Button,
  Collapse,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import SimpleHeader from "../../../../components/Headers/SimpleHeader";
import TrelloFilters, { FiltrosState, contagemFiltros } from "./TrelloFilters";
// @ts-ignore
import { usePersistedState } from "../../../../hooks";
import EmpresaContext from "../../../../contexts/Empresa";
import AuthContext from "../../../../contexts/Auth";
import api from "../../../../services/api";
import PipelineKanban from "./PipelineKanban";
import CardSidebar from "./CardSidebar";
import CardForm from "./CardForm";
import OportunidadesForm from "../../Oportunidades/Form";
// @ts-ignore
import ClienteForm from "../../../common/Clientes/Form";
import EstagiosBreadcrumb from "../../../../components/EstagiosBreadcrumb";
import {
  SidebarBackdrop,
  SidebarPanel,
  SidebarHeader,
  SidebarBody,
  SidebarToggle,
  RightSidebarPanel,
} from "./styles";

interface Funil {
  id: number;
  nome: string;
  pasta_id?: number;
}

interface Pasta {
  id: number;
  nome: string;
}

interface Estagio {
  id?: number;
  estagio_id?: number;
  nome: string;
  cor?: string;
}

interface CardData {
  id: number;
  titulo: string;
  descricao?: string;
  estagio_id: number;
  prioridade?: string;
  situacao?: string;
  data_prazo?: string;
  data_inicio?: string;
  data_conclusao?: string;
  ordem: number;
  tags?: string;
  entidade_id?: number;
  criador?: any;
  membros?: any[];
  entidade_tipo?: string;
}

const MeusPipelines: React.FC = (props: any) => {
  const { empresaSelecionada } = useContext(EmpresaContext);
  const { hasRole, user } = useContext(AuthContext);
  const [funis, setFunis] = useState<Funil[]>([]);
  const [pastas, setPastas] = useState<Pasta[]>([]);
  const [pastasExpandidas, setPastasExpandidas] = useState<Set<number>>(new Set());
  const [funilSelecionado, setFunilSelecionado] = useState<string | null>(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    const sidenav = document.querySelector(".sidenav");

    function updateSidenavRight() {
      if (sidenav) {
        const rect = sidenav.getBoundingClientRect();
        document.documentElement.style.setProperty('--sidenav-width', `${Math.max(0, rect.right)}px`);
      }
    }

    updateSidenavRight();

    let observer: ResizeObserver | null = null;
    let rafId: number | null = null;

    if (sidenav && typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(() => {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(updateSidenavRight);
      });
      observer.observe(sidenav);
    }

    window.addEventListener("resize", updateSidenavRight);

    return () => {
      window.removeEventListener("resize", updateSidenavRight);
      if (observer) observer.disconnect();
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);
  const [estagios, setEstagios] = useState<Estagio[]>([]);
  const [cards, setCards] = useState<CardData[]>([]);
  const [estagiosSelecionados, setEstagiosSelecionados] = useState<(number | string)[]>([]);
  const [lanes, setLanes] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const notificationAlert = useRef<any>(null);

  // Filter state (Trello-style multi)
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [busca, setBusca] = usePersistedState('pipe_busca', '');
  const [prioridade, setPrioridade] = usePersistedState('pipe_prioridade', []);
  const [situacao, setSituacao] = usePersistedState('pipe_situacao', []);
  const [membros_ids, setMembrosIds] = usePersistedState('pipe_membros', []);
  const [tags, setTags] = usePersistedState('pipe_tags', '');
  const [dataPrazoInicial, setDataPrazoInicial] = usePersistedState('pipe_prazo_ini', '');
  const [dataPrazoFinal, setDataPrazoFinal] = usePersistedState('pipe_prazo_fim', '');
  const [prazoQuick, setPrazoQuick] = usePersistedState('pipe_prazo_quick', []);
  const [semMembros, setSemMembros] = usePersistedState('pipe_sem_membros', false);
  const [atribuidosAMim, setAtribuidosAMim] = usePersistedState('pipe_atribuidos_mim', false);
  const [colaboradores, setColaboradores] = useState<any[]>([]);
  const skipNextFilterApply = useRef(true);

  // Modal State — card
  const [modalOpen, setModalOpen] = useState(false);
  const [cardSelecionado, setCardSelecionado] = useState<any>(null);

  // Modal State — novo estágio
  const [estagioModalOpen, setEstagioModalOpen] = useState(false);
  const [novoEstagioNome, setNovoEstagioNome] = useState('');
  const [novoEstagioCor, setNovoEstagioCor] = useState('#5e72e4');
  const [savingEstagio, setSavingEstagio] = useState(false);

  // Sidebar State — detalhes da oportunidade
  const [rightSidebarOpen, setRightSidebarOpen] = useState(false);
  const [oportunidadeIdParaDetalhes, setOportunidadeIdParaDetalhes] = useState<number | null>(null);

  // Sidebar State — detalhes do cliente
  const [clienteSidebarOpen, setClienteSidebarOpen] = useState(false);
  const [clienteIdParaDetalhes, setClienteIdParaDetalhes] = useState<number | null>(null);

  // Sidebar State — detalhes de card vinculado
  const [cardSidebarOpen, setCardSidebarOpen] = useState(false);
  const [cardParaDetalhes, setCardParaDetalhes] = useState<any>(null);
  const [estagiosCardDetalhes, setEstagiosCardDetalhes] = useState<Estagio[]>([]);
  const [cardDetalhesTitulo, setCardDetalhesTitulo] = useState('');
  const [cardDetalhesTituloFocused, setCardDetalhesTituloFocused] = useState(false);
  const cardDetalhesTituloRef = useRef<HTMLInputElement>(null);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    if (modalOpen) setCardSelecionado(null);
  };

  const handleEditCard = (card: any) => {
    setCardSelecionado(card);
    setModalOpen(true);
  };

  const handleVerEntidade = async (tipo: string, id: number) => {
    if (tipo === 'oportunidade') {
      setOportunidadeIdParaDetalhes(id);
      setRightSidebarOpen(true);
    } else if (tipo === 'cliente') {
      setClienteIdParaDetalhes(id);
      setClienteSidebarOpen(true);
    } else if (tipo === 'card') {
      try {
        const cardRes = await api.get(`/common/empresas/${empresaSelecionada?.id}/cards/${id}`);
        const cardData = cardRes.data;
        setCardParaDetalhes(cardData);
        setCardDetalhesTitulo(cardData.titulo || '');
        if (cardData.funil_id) {
          const stagesRes = await api.get(`/common/empresas/${empresaSelecionada?.id}/funis/${cardData.funil_id}/estagios`);
          setEstagiosCardDetalhes(stagesRes.data);
        }
        setCardSidebarOpen(true);
      } catch (error) {
        notify('danger', 'Falha ao carregar detalhes do card.');
      }
    }
  };

  const handleAddCard = (laneId: string | number) => {
    setCardSelecionado({ estagio_id: Number(laneId) });
    setModalOpen(true);
  };

  const handleCriarCardFromCard = (card: any) => {
    setCardSelecionado({
      estagio_id: Number(card.laneId || card.estagio_id),
      entidade_tipo: 'card',
      entidade_id: Number(card.id),
      descricao: `Criado a partir do card #${card.id}`,
    });
    setModalOpen(true);
  };

  function notify(type: string, msg: string) {
    const options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span data-notify="message">{msg}</span>
        </div>
      ),
      type,
      icon: "ni ni-bell-55",
      autoDismiss: 7,
    };
    if (notificationAlert.current) {
      notificationAlert.current.notificationAlert(options);
    }
  }

  // Carrega funis do tipo pipeline e pastas
  useEffect(() => {
    if (empresaSelecionada?.id) {
      loadFunis();
      loadPastas();
      loadColaboradores();
    }
  }, [empresaSelecionada]);

  async function loadFunis() {
    try {
      const response = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/funis/?tipo=pipeline`
      );
      const data = response.data?.rows || response.data;
      const lista: Funil[] = Array.isArray(data) ? data : [];
      setFunis(lista);

      const lsKey = `playnee_last_pipeline_${empresaSelecionada?.id}`;
      const saved = localStorage.getItem(lsKey);
      if (saved && lista.some(f => String(f.id) === saved)) {
        setFunilSelecionado(saved);
        setSidebarOpen(false);
      } else {
        // Pipeline salvo saiu da lista disponível: não deixa a tela presa nele.
        if (saved) localStorage.removeItem(lsKey);
        setFunilSelecionado((atual) =>
          atual && lista.some(f => String(f.id) === String(atual)) ? atual : null
        );
      }
    } catch (error) {
      console.error(error);
      notify("danger", "Falha ao carregar pipelines.");
    }
  }

  async function loadColaboradores() {
    try {
      const res = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/colaboradores?situacaoNaEmpresa=A`
      );
      setColaboradores(res.data || []);
    } catch {
      // silent — filters still work, just no collaborator list
    }
  }

  async function loadPastas() {
    try {
      const response = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/pastas-funis`,
        { params: { situacao: "A" } }
      );
      const data = response.data?.data || response.data || [];
      const lista: Pasta[] = Array.isArray(data) ? data : [];
      setPastas(lista);
      setPastasExpandidas(new Set(lista.map((p) => p.id)));
    } catch (error) {
      console.error(error);
      notify("danger", "Falha ao carregar pastas.");
    }
  }

  function togglePasta(pastaId: number) {
    setPastasExpandidas((prev) => {
      const next = new Set(prev);
      if (next.has(pastaId)) next.delete(pastaId);
      else next.add(pastaId);
      return next;
    });
  }

  // Pipelines agrupadas por pasta (apenas pastas que possuem pipelines + grupo "Sem pasta" se houver órfãos)
  const pipelinesAgrupadas = useMemo(() => {
    const grupos = pastas.map((p) => ({
      id: p.id,
      nome: p.nome,
      funis: funis.filter((f) => f.pasta_id === p.id),
    }));
    const semPasta = funis.filter((f) => !f.pasta_id);
    if (semPasta.length > 0) {
      grupos.push({ id: 0, nome: "Sem pasta", funis: semPasta });
    }
    return grupos;
  }, [pastas, funis]);

  // Garante que a pasta do pipeline selecionado esteja expandida
  useEffect(() => {
    if (!funilSelecionado) return;
    const funil = funis.find((f) => String(f.id) === String(funilSelecionado));
    const pastaId = funil?.pasta_id ?? 0;
    setPastasExpandidas((prev) => {
      if (prev.has(pastaId)) return prev;
      const next = new Set(prev);
      next.add(pastaId);
      return next;
    });
  }, [funilSelecionado, funis]);

  // Quando seleciona um funil, carrega estágios e cards
  useEffect(() => {
    if (funilSelecionado) {
      setEstagiosSelecionados([]);
      skipNextFilterApply.current = true;
      setBusca('');
      setPrioridade([]);
      setSituacao([]);
      setMembrosIds([]);
      setTags('');
      setDataPrazoInicial('');
      setDataPrazoFinal('');
      setPrazoQuick([]);
      setSemMembros(false);
      setAtribuidosAMim(false);
      loadEstagiosECards(funilSelecionado);
    } else {
      setLanes([]);
      setEstagios([]);
      setCards([]);
    }
  }, [funilSelecionado]);

  async function loadEstagiosECards(funilId: string | number) {
    setLoading(true);
    try {
      // Carrega estágios do funil
      const estagiosRes = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/funis/${funilId}/estagios`
      );
      const estagiosList = estagiosRes.data;
      setEstagios(estagiosList);

      // Carrega cards do funil
      const cardsRes = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/funis/${funilId}/cards`
      );
      const cardsData = cardsRes.data?.data || cardsRes.data;
      setCards(cardsData);

    } catch (error) {
      console.error(error);
      notify("danger", "Falha ao carregar estágios e cards.");
    }
    setLoading(false);
  }

  async function loadCards(filtros: Record<string, any> = {}) {
    if (!funilSelecionado) return;
    try {
      const cardsRes = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/funis/${funilSelecionado}/cards`,
        { params: filtros }
      );
      const cardsData = cardsRes.data?.data || cardsRes.data;
      setCards(Array.isArray(cardsData) ? cardsData : []);
    } catch (error) {
      console.error(error);
      notify('danger', 'Falha ao carregar cards.');
    }
  }

  function handleFiltroChange(campo: keyof FiltrosState, valor: any) {
    const setterMap: Record<string, (v: any) => void> = {
      busca: setBusca,
      prioridade: setPrioridade,
      situacao: setSituacao,
      membros_ids: setMembrosIds,
      tags: setTags,
      dataPrazoInicial: setDataPrazoInicial,
      dataPrazoFinal: setDataPrazoFinal,
      prazoQuick: setPrazoQuick,
      semMembros: setSemMembros,
      atribuidosAMim: setAtribuidosAMim,
    };
    const setter = setterMap[campo];
    if (setter) setter(valor);
  }

  // Converte os quick filters de prazo em params pro backend.
  // Estratégia: une todos os intervalos selecionados num range único (menor inicial, maior final).
  // "sem_prazo" é uma flag separada (semPrazo=true).
  function computarPrazoFromQuick(quick: string[]): { dataPrazoInicial?: string; dataPrazoFinal?: string; semPrazo?: boolean } {
    if (!quick.length) return {};
    const hoje = new Date();
    const fmt = (d: Date) => d.toISOString().slice(0, 10);
    let inicial: Date | null = null;
    let final: Date | null = null;
    let semPrazoFlag = false;

    for (const q of quick) {
      if (q === 'sem_prazo') { semPrazoFlag = true; continue; }
      let di: Date | null = null;
      let df: Date | null = null;
      if (q === 'atraso') {
        df = new Date(hoje); df.setDate(df.getDate() - 1);
      } else if (q === 'hoje') {
        di = new Date(hoje); df = new Date(hoje);
      } else if (q === 'dia') {
        di = new Date(hoje); df = new Date(hoje); df.setDate(df.getDate() + 1);
      } else if (q === 'semana') {
        di = new Date(hoje); df = new Date(hoje); df.setDate(df.getDate() + 7);
      } else if (q === 'mes') {
        di = new Date(hoje); df = new Date(hoje); df.setDate(df.getDate() + 30);
      }
      if (di && (!inicial || di < inicial)) inicial = di;
      if (df && (!final || df > final)) final = df;
    }
    const out: any = {};
    if (semPrazoFlag) out.semPrazo = true;
    if (inicial) out.dataPrazoInicial = fmt(inicial);
    if (final) out.dataPrazoFinal = fmt(final);
    return out;
  }

  function handlePesquisar() {
    const prazoFromQuick = computarPrazoFromQuick(prazoQuick);

    // membros_ids efetivos = manual + "atribuídos a mim" (se ativo)
    let membrosEfetivos: string[] = [...(membros_ids as string[])];
    if (atribuidosAMim && user?.id) {
      const uid = String(user.id);
      if (!membrosEfetivos.includes(uid)) membrosEfetivos.push(uid);
    }

    loadCards({
      busca: busca || undefined,
      prioridade: (prioridade as string[]).length ? (prioridade as string[]).join(',') : undefined,
      situacao: (situacao as string[]).length ? (situacao as string[]).join(',') : undefined,
      membros_ids: membrosEfetivos.length ? membrosEfetivos.join(',') : undefined,
      tags: tags || undefined,
      dataPrazoInicial: prazoFromQuick.dataPrazoInicial || dataPrazoInicial || undefined,
      dataPrazoFinal: prazoFromQuick.dataPrazoFinal || dataPrazoFinal || undefined,
      semPrazo: prazoFromQuick.semPrazo ? 'true' : undefined,
      semMembros: semMembros ? 'true' : undefined,
    });
  }

  // Auto-aplica filtros (debounced) quando qualquer um muda
  useEffect(() => {
    if (skipNextFilterApply.current) {
      skipNextFilterApply.current = false;
      return;
    }
    if (!funilSelecionado) return;
    const timer = setTimeout(() => {
      handlePesquisar();
    }, 350);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busca, tags, prioridade, situacao, membros_ids, dataPrazoInicial, dataPrazoFinal, prazoQuick, semMembros, atribuidosAMim]);

  function handleLimparFiltros() {
    setBusca('');
    setPrioridade([]);
    setSituacao([]);
    setMembrosIds([]);
    setTags('');
    setDataPrazoInicial('');
    setDataPrazoFinal('');
    setPrazoQuick([]);
    setSemMembros(false);
    setAtribuidosAMim(false);
    // o useEffect de auto-apply recarrega os cards após o reset
  }

  // Monta as lanes sempre que os estagios, cards ou filtros mudarem
  useEffect(() => {
    if (estagios.length > 0) {
      const estagiosFiltrados = estagiosSelecionados.length > 0 
        ? estagios.filter(e => estagiosSelecionados.includes(Number(e.id || e.estagio_id)))
        : estagios;

      const lanesData = estagiosFiltrados.map((estagio) => ({
        id: String(estagio.estagio_id || estagio.id),
        title: estagio.nome,
        barColor: estagio.cor || "#5e72e4",
        cards: (Array.isArray(cards) ? cards : [])
          .filter((c) => c.estagio_id === (estagio.estagio_id || estagio.id))
          .sort((a, b) => a.ordem - b.ordem)
          .map((card) => ({
            id: String(card.id),
            title: card.titulo,
            description: card.descricao || "",
            prioridade: card.prioridade,
            situacao: card.situacao,
            data_prazo: card.data_prazo,
            data_inicio: card.data_inicio,
            data_conclusao: card.data_conclusao,
            laneId: String(card.estagio_id),
            tags: card.tags || "",
            criador: card.criador,
            membros: card.membros || [],
            entidade_tipo: card.entidade_tipo,
            entidade_id: card.entidade_id,
            cardColor: estagio.cor || "#5e72e4",
          })),
      }));

      setLanes(lanesData);
    } else {
      setLanes([]);
    }
  }, [estagios, cards, estagiosSelecionados]);

  async function handleMoverCard(cardId: string, _sourceLaneId: string, targetLaneId: string) {
    try {
      await api.put(
        `/common/empresas/${empresaSelecionada?.id}/funis/${funilSelecionado}/cards/${cardId}/mover`,
        { estagio_destino_id: Number(targetLaneId) }
      );
      // Atualiza o estado local para evitar recarregar tudo do servidor
      setCards(prevCards => prevCards.map(c =>
        String(c.id) === String(cardId)
          ? { ...c, estagio_id: Number(targetLaneId) }
          : c
      ));
    } catch (error) {
      console.error(error);
      notify("danger", "Falha ao mover card.");
      if (funilSelecionado) loadEstagiosECards(funilSelecionado);
    }
  }

  async function handleSalvarEstagio() {
    if (!novoEstagioNome.trim()) return;
    setSavingEstagio(true);
    try {
      const res = await api.post(
        `/common/empresas/${empresaSelecionada?.id}/estagios/`,
        { nome: novoEstagioNome.trim(), cor: novoEstagioCor }
      );
      const estagioId = res.data?.estagio_id || res.data?.id;
      await api.post(
        `/common/empresas/${empresaSelecionada?.id}/funis/${funilSelecionado}/estagios/${estagioId}`
      );
      setEstagioModalOpen(false);
      setNovoEstagioNome('');
      setNovoEstagioCor('#5e72e4');
      await loadEstagiosECards(funilSelecionado!);
    } catch (error) {
      console.error(error);
      notify('danger', 'Falha ao criar estágio.');
    }
    setSavingEstagio(false);
  }

  async function handleChangeSituacao(cardId: string, novaSituacao: string) {
    try {
      await api.put(
        `/common/empresas/${empresaSelecionada?.id}/funis/${funilSelecionado}/cards/${cardId}`,
        { situacao: novaSituacao }
      );
      setCards(prevCards => prevCards.map(c =>
        String(c.id) === String(cardId)
          ? {
              ...c,
              situacao: novaSituacao,
              data_conclusao: novaSituacao === "concluido" ? new Date().toISOString() : c.data_conclusao,
            }
          : c
      ));
    } catch (error) {
      console.error(error);
      notify("danger", "Falha ao atualizar situação.");
      if (funilSelecionado) loadEstagiosECards(funilSelecionado);
    }
  }

  return (
    <>
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>
      <SimpleHeader
        name="Meus Pipelines"
        parentName="Pipelines"
        {...props}
      />
      <div className="">
        <Row>
          <Col>
            <Card>
              <CardHeader
                className="d-flex justify-content-between align-items-center flex-wrap"
                style={{
                  position: "sticky",
                  top: "0px",
                  zIndex: 200,
                  paddingBottom: "0px",
                  gap: "10px",
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                  <h1 className="mb-0">Pipeline</h1>
                  {funilSelecionado && (
                    <span style={{ fontSize: '0.85rem', color: '#8898aa', fontWeight: 400 }}>
                      {funis.find(f => String(f.id) === funilSelecionado)?.nome}
                    </span>
                  )}
                </div>
                <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                  {(() => {
                    const filtrosState: FiltrosState = {
                      busca, prioridade, situacao, membros_ids, tags,
                      dataPrazoInicial, dataPrazoFinal, prazoQuick, semMembros, atribuidosAMim,
                    };
                    const total = contagemFiltros(filtrosState);
                    return (
                      <>
                        <Button
                          size="sm"
                          color={total > 0 ? 'primary' : 'secondary'}
                          outline={total === 0}
                          onClick={() => setFiltersOpen(true)}
                          style={{ height: 32, display: 'inline-flex', alignItems: 'center', gap: 6 }}
                        >
                          <i className="fa fa-filter" />
                          <span>Filtrar Cartões</span>
                          {total > 0 && (
                            <span
                              style={{
                                background: '#fff', color: '#5e72e4',
                                fontSize: '0.7rem', fontWeight: 700,
                                padding: '1px 7px', borderRadius: 10, marginLeft: 2,
                              }}
                            >
                              {total}
                            </span>
                          )}
                        </Button>
                        {total > 0 && (
                          <span
                            role="button"
                            onClick={handleLimparFiltros}
                            title="Limpar todos os filtros"
                            style={{
                              fontSize: '0.82rem',
                              color: '#5e72e4',
                              cursor: 'pointer',
                              userSelect: 'none',
                              padding: '4px 8px',
                              borderRadius: 4,
                              fontWeight: 500,
                              transition: 'background 0.12s, color 0.12s',
                            }}
                            onMouseEnter={e => {
                              e.currentTarget.style.background = '#eaf1ff';
                            }}
                            onMouseLeave={e => {
                              e.currentTarget.style.background = 'transparent';
                            }}
                          >
                            Limpar tudo
                          </span>
                        )}
                      </>
                    );
                  })()}
                </div>

                <EstagiosBreadcrumb
                  estagios={estagios}
                  selecionados={estagiosSelecionados}
                  onChange={setEstagiosSelecionados}
                />
              </CardHeader>
              <CardBody style={{ paddingTop: "0px" }}>
                {loading ? (
                  <div className="text-center py-5">
                    <Spinner color="primary" />
                    <p className="mt-2 text-muted">Carregando pipeline...</p>
                  </div>
                ) : !funilSelecionado ? (
                  <div className="text-center py-5">
                    <i
                      className="fas fa-columns"
                      style={{ fontSize: 48, color: "#dee2e6" }}
                    />
                    <p className="mt-3 text-muted">
                      Selecione um pipeline na lateral para visualizar o quadro.
                    </p>
                  </div>
                ) : estagios.length === 0 ? (
                  <div className="text-center py-5">
                    <i
                      className="fas fa-inbox"
                      style={{ fontSize: 48, color: "#dee2e6" }}
                    />
                    <p className="mt-3 text-muted">
                      Este pipeline não possui estágios configurados.
                    </p>
                  </div>
                ) : (
                  <PipelineKanban
                    lanes={lanes}
                    onMoverCard={handleMoverCard}
                    onCardClick={handleEditCard}
                    onAddCard={handleAddCard}
                    onVerEntidade={handleVerEntidade}
                    onChangeSituacao={handleChangeSituacao}
                    onCriarCardFromCard={handleCriarCardFromCard}
                    onAddLane={
                      hasRole('gestor_comercial') || 
                      hasRole('gestor_marketing') || 
                      hasRole('administrador_empresa') || 
                      hasRole('administrador')
                        ? () => setEstagioModalOpen(true)
                        : undefined
                    }
                    loading={loading}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <SidebarBackdrop
        open={sidebarOpen}
        onClick={() => setSidebarOpen(false)}
      />
      <SidebarToggle
        type="button"
        open={sidebarOpen}
        onClick={() => setSidebarOpen((v) => !v)}
        aria-label={sidebarOpen ? "Fechar pipelines" : "Abrir pipelines"}
        title={sidebarOpen ? "Fechar pipelines" : "Abrir pipelines"}
      >
        <i className="fas fa-filter" />
      </SidebarToggle>
      <SidebarPanel open={sidebarOpen}>
        <SidebarHeader>
          <h3 className="mb-0">Pipelines</h3>
        </SidebarHeader>
        <SidebarBody>
          {funis.length === 0 ? (
            <small className="text-muted" style={{ fontSize: "0.75rem" }}>
              Não existem pipelines disponíveis para o seu usuário. Fale com o
              administrador da empresa para ser atribuído a um pipeline.
            </small>
          ) : pipelinesAgrupadas.length === 0 ? (
            <small className="text-muted" style={{ fontSize: "0.75rem" }}>
              Nenhuma pasta encontrada.
            </small>
          ) : (
            pipelinesAgrupadas.map((pasta) => {
              const expandido = pastasExpandidas.has(pasta.id);
              return (
                <div key={pasta.id} className="mb-2">
                  <div
                    className="d-flex align-items-center justify-content-between"
                    style={{
                      cursor: "pointer",
                      userSelect: "none",
                      padding: "6px 4px",
                      fontSize: "0.8125rem",
                      fontWeight: 600,
                      color: "#32325d",
                      letterSpacing: "0.01em",
                    }}
                    onClick={() => togglePasta(pasta.id)}
                  >
                    <span className="text-truncate">{pasta.nome}</span>
                    <i
                      className={`fas fa-chevron-${expandido ? "down" : "right"}`}
                      style={{ fontSize: "0.65rem", color: "#8898aa" }}
                    />
                  </div>
                  <Collapse isOpen={expandido}>
                    <div style={{ paddingTop: 2 }}>
                      {pasta.funis.length === 0 ? (
                        <small
                          className="d-block"
                          style={{
                            fontSize: "0.75rem",
                            color: "#8898aa",
                            padding: "4px 8px",
                          }}
                        >
                          Sem pipelines
                        </small>
                      ) : (
                        pasta.funis.map((f) => {
                          const isSelecionado =
                            String(f.id) === String(funilSelecionado);
                          return (
                            <div
                              key={f.id}
                              onClick={() => {
                                const id = String(f.id);
                                setFunilSelecionado(id);
                                localStorage.setItem(`playnee_last_pipeline_${empresaSelecionada?.id}`, id);
                                setSidebarOpen(false);
                              }}
                              className="d-flex align-items-center"
                              style={{
                                cursor: "pointer",
                                padding: "6px 10px",
                                marginBottom: 2,
                                borderRadius: 6,
                                fontSize: "0.8125rem",
                                fontWeight: isSelecionado ? 500 : 400,
                                backgroundColor: isSelecionado
                                  ? "#eaf1ff"
                                  : "transparent",
                                color: isSelecionado ? "#2c5fd9" : "#525f7f",
                                transition:
                                  "background-color 0.15s ease-in-out, color 0.15s ease-in-out",
                              }}
                              onMouseEnter={(e) => {
                                if (!isSelecionado)
                                  e.currentTarget.style.backgroundColor =
                                    "#f6f9fc";
                              }}
                              onMouseLeave={(e) => {
                                if (!isSelecionado)
                                  e.currentTarget.style.backgroundColor =
                                    "transparent";
                              }}
                            >
                              <i
                                className="fas fa-filter"
                                style={{
                                  fontSize: "0.7rem",
                                  marginRight: 8,
                                  opacity: isSelecionado ? 1 : 0.6,
                                }}
                              />
                              <span className="text-truncate">{f.nome}</span>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </Collapse>
                </div>
              );
            })
          )}
        </SidebarBody>
      </SidebarPanel>

      <Modal isOpen={estagioModalOpen} toggle={() => setEstagioModalOpen(false)} size="sm">
        <ModalHeader toggle={() => setEstagioModalOpen(false)}>Novo estágio</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Nome *</Label>
            <Input
              value={novoEstagioNome}
              onChange={(e) => setNovoEstagioNome(e.target.value)}
              placeholder="Ex: Proposta enviada"
              onKeyDown={(e) => { if (e.key === 'Enter') handleSalvarEstagio(); }}
              autoFocus
            />
          </FormGroup>
          <FormGroup className="mb-0">
            <Label>Cor</Label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <input
                type="color"
                value={novoEstagioCor}
                onChange={(e) => setNovoEstagioCor(e.target.value)}
                style={{
                  width: '40px', height: '38px', padding: '2px',
                  border: '1px solid #dee2e6', borderRadius: '4px', cursor: 'pointer',
                }}
              />
              <span style={{ fontSize: '13px', color: '#6c757d' }}>{novoEstagioCor}</span>
            </div>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setEstagioModalOpen(false)}>
            Cancelar
          </Button>
          <Button
            color="primary"
            onClick={handleSalvarEstagio}
            disabled={!novoEstagioNome.trim() || savingEstagio}
          >
            {savingEstagio ? <Spinner size="sm" /> : 'Criar estágio'}
          </Button>
        </ModalFooter>
      </Modal>

      {funilSelecionado && (
        <CardSidebar
          /*
           * A key força remontagem do CardSidebar sempre que o "card" alvo muda
           * (novo card em estágio X, novo card em estágio Y, edição de um card
           * específico). Isso garante que o useState initializer rode com o
           * card correto e o Select2 de estágio inicialize já com o valor certo,
           * evitando o timing issue do react-select2-wrapper em sidebars.
           */
          key={
            cardSelecionado
              ? cardSelecionado.id
                ? `edit-${cardSelecionado.id}`
                : `new-${cardSelecionado.estagio_id ?? 'default'}`
              : 'closed'
          }
          isOpen={modalOpen}
          onClose={toggleModal}
          funilId={funilSelecionado}
          estagios={estagios}
          card={cardSelecionado}
          onSuccess={() => loadEstagiosECards(funilSelecionado)}
          notify={notify}
        />
      )}

      {/* Sidebar de Detalhes da Oportunidade */}
      <SidebarBackdrop
        open={rightSidebarOpen}
        onClick={() => {
          setRightSidebarOpen(false);
          setOportunidadeIdParaDetalhes(null);
        }}
        style={{ zIndex: 1049 }}
      />
      <RightSidebarPanel open={rightSidebarOpen}>
        <SidebarHeader>
          <h3 className="mb-0">Detalhes da Oportunidade</h3>
          <i
            className="fas fa-times"
            onClick={() => {
              setRightSidebarOpen(false);
              setOportunidadeIdParaDetalhes(null);
            }}
            style={{ cursor: 'pointer', fontSize: '1.2rem', color: '#8898aa' }}
          />
        </SidebarHeader>
        <SidebarBody style={{ padding: 0 }}>
          {oportunidadeIdParaDetalhes && (
            <OportunidadesForm
              key={oportunidadeIdParaDetalhes}
              oportunidadeId={oportunidadeIdParaDetalhes}
              readOnly={undefined}
              oportunidadeIdToCrossSelling={undefined}
              tipoCrossSelling={undefined}
              coordenadas={undefined}
              onClose={() => {
                setRightSidebarOpen(false);
                setOportunidadeIdParaDetalhes(null);
              }}
            />
          )}
        </SidebarBody>
      </RightSidebarPanel>

      {/* Sidebar de Detalhes do Cliente */}
      <SidebarBackdrop
        open={clienteSidebarOpen}
        onClick={() => setClienteSidebarOpen(false)}
        style={{ zIndex: 1049 }}
      />
      <RightSidebarPanel open={clienteSidebarOpen}>
        <SidebarHeader>
          <h3 className="mb-0">Detalhes do Cliente</h3>
          <i
            className="fas fa-times"
            onClick={() => setClienteSidebarOpen(false)}
            style={{ cursor: 'pointer', fontSize: '1.2rem', color: '#8898aa' }}
          />
        </SidebarHeader>
        <SidebarBody style={{ padding: 0 }}>
          {clienteIdParaDetalhes && (
            <ClienteForm
              clienteId={clienteIdParaDetalhes}
              showHeader={false}
              history={props.history}
              onSuccess={() => setClienteSidebarOpen(false)}
              goBack={() => setClienteSidebarOpen(false)}
              onTelefonesChange={() => {}}
            />
          )}
        </SidebarBody>
      </RightSidebarPanel>

      {/* Sidebar de Detalhes do Card vinculado */}
      <SidebarBackdrop
        open={cardSidebarOpen}
        onClick={() => setCardSidebarOpen(false)}
        style={{ zIndex: 1049 }}
      />
      <RightSidebarPanel open={cardSidebarOpen}>
        <SidebarHeader>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', flex: 1, minWidth: 0 }}>
            <div style={{ position: 'relative', display: 'inline-block', minWidth: '60px', maxWidth: '100%' }}>
              <span
                aria-hidden
                style={{
                  visibility: 'hidden',
                  whiteSpace: 'pre',
                  fontSize: '1.1rem',
                  fontWeight: 600,
                  display: 'block',
                  padding: '0 2px 2px 0',
                }}
              >
                {cardDetalhesTitulo || 'Ver card'}
              </span>
              <input
                ref={cardDetalhesTituloRef}
                value={cardDetalhesTitulo}
                onChange={e => setCardDetalhesTitulo(e.target.value)}
                placeholder="Ver card"
                style={{
                  position: 'absolute',
                  inset: 0,
                  width: '100%',
                  fontSize: '1.1rem',
                  fontWeight: 600,
                  color: '#32325d',
                  background: 'transparent',
                  border: 'none',
                  borderBottom: `2px solid ${cardDetalhesTituloFocused ? '#5e72e4' : 'transparent'}`,
                  outline: 'none',
                  padding: '0',
                  transition: 'border-color 0.15s ease',
                }}
                onFocus={() => setCardDetalhesTituloFocused(true)}
                onBlur={() => setCardDetalhesTituloFocused(false)}
              />
            </div>
            <i
              className="fas fa-pencil-alt"
              onClick={() => cardDetalhesTituloRef.current?.focus()}
              style={{
                fontSize: '0.75rem',
                color: cardDetalhesTituloFocused ? '#5e72e4' : '#adb5bd',
                cursor: 'pointer',
                transition: 'color 0.15s ease',
                flexShrink: 0,
              }}
            />
          </div>
          <i
            className="fas fa-times"
            onClick={() => setCardSidebarOpen(false)}
            style={{ cursor: 'pointer', fontSize: '1.2rem', color: '#8898aa', flexShrink: 0 }}
          />
        </SidebarHeader>
        <SidebarBody style={{ padding: 0 }}>
          {cardParaDetalhes && (
            <CardForm
              key={cardParaDetalhes.id}
              card={cardParaDetalhes}
              funilId={cardParaDetalhes.funil_id}
              estagios={estagiosCardDetalhes}
              tituloExterno={cardDetalhesTitulo}
              onSuccess={() => {
                setCardSidebarOpen(false);
                if (funilSelecionado) loadEstagiosECards(funilSelecionado);
              }}
              onCancel={() => setCardSidebarOpen(false)}
              notify={notify}
            />
          )}
        </SidebarBody>
      </RightSidebarPanel>

      {/* Sidebar de Filtros (estilo Trello) */}
      <TrelloFilters
        open={filtersOpen}
        onClose={() => setFiltersOpen(false)}
        filtros={{
          busca, prioridade, situacao, membros_ids, tags,
          dataPrazoInicial, dataPrazoFinal, prazoQuick, semMembros, atribuidosAMim,
        }}
        onChange={handleFiltroChange}
        colaboradores={colaboradores}
        currentUserId={user?.id ?? undefined}
      />
    </>
  );
};

export default MeusPipelines;
